var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptlayerCakeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "symbol",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC483;}\n\t.st1{fill:#FFED9F;}\n\t.st2{fill:#7ACC7A;}\n\t.st3{fill:#F04C74;}\n\t.st4{fill:#374151;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2089.5,945.7c0-0.1,0-0.1,0-0.2c0-0.4,0-0.8,0-1.2c0-0.2,0-0.3,0-0.5c0-0.3-0.1-0.6-0.1-0.9 c0-0.2,0-0.3-0.1-0.5c0-0.3-0.1-0.6-0.1-0.9c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.3-0.1-0.7-0.2-1c0-0.1,0-0.2-0.1-0.3 c-0.1-0.4-0.2-0.9-0.4-1.3c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.3-0.2-0.6-0.4-0.8 c-0.1-0.2-0.1-0.3-0.2-0.5c-0.2-0.3-0.3-0.7-0.5-1c0-0.1-0.1-0.2-0.1-0.2c-5.4-10.1-132.1-229.5-845.8-229.5 c-60.1,0-124.4,1.6-193.1,4.9c-4.1,0.2-8,1.4-11.5,3.5l-614,372.8c-0.1,0.1-0.2,0.2-0.4,0.2c-0.4,0.3-0.8,0.5-1.2,0.8 c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.2-0.6,0.5-1,0.8c-0.2,0.2-0.4,0.4-0.6,0.5c-0.3,0.3-0.6,0.5-0.8,0.8c-0.2,0.2-0.4,0.4-0.6,0.6 c-0.3,0.3-0.5,0.5-0.7,0.8c-0.2,0.2-0.4,0.4-0.5,0.6c-0.3,0.3-0.5,0.6-0.7,1c-0.1,0.2-0.3,0.4-0.4,0.6c-0.4,0.5-0.7,1.1-1,1.6 c-0.1,0.1-0.1,0.3-0.2,0.4c-0.2,0.4-0.5,0.9-0.7,1.3c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0.4-0.3,0.8-0.5,1.2c-0.1,0.2-0.2,0.5-0.2,0.7 c-0.1,0.4-0.3,0.8-0.4,1.2c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.4-0.2,0.8-0.3,1.1c-0.1,0.3-0.1,0.5-0.2,0.8c-0.1,0.4-0.1,0.7-0.2,1.1 c0,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.7-0.1,1c0,0.3,0,0.6,0,0.9c0,0.1,0,0.1,0,0.2v258.5v313.4v258.5c0,6.9,2.9,13.5,8,18.1 c4.5,4.1,10.4,6.3,16.4,6.3c0.8,0,1.6,0,2.4-0.1l1630.1-161c12.5-1.2,22-11.8,22-24.3v-258.5v-313.4L2089.5,945.7 C2089.5,945.7,2089.5,945.7,2089.5,945.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2040.6,1231.3 459.4,1387.4 459.4,1651.7 2040.6,1495.5  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1567.4,772.1c118,14.9,219.5,38.8,301.7,70.9c72.7,28.4,116.4,58.2,140.2,78.1c2,1.7,3.9,3.4,5.8,5 L539.6,1071.8l516.7-313.7C1249.3,748.9,1421.2,753.6,1567.4,772.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1604.8,702.8c56.7,8.8,90.3-56.7,90.3-56.7s-68.3-25.2-82.1-102.9c-77.7-13.8-102.9-82.1-102.9-82.1 s-65.5,33.6-56.7,90.3L1604.8,702.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1618.6,833.3c-81.7,81.7-261.6,129.2-343.2,47.5s-34.1-261.6,47.5-343.2c81.7-81.7,166.5-34.1,248.1,47.5 S1700.2,751.7,1618.6,833.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptlayerCakeColor);
export default __webpack_public_path__ + "static/media/promptlayer-cake-color.b89a87f96c4da9eea3508be90c47b2cb.svg";
export { ForwardRef as ReactComponent };